import { css } from '@emotion/react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import Status from 'components/field/Status';

import useAlert from 'hooks/useAlert';
import useLocale from 'hooks/useLocale';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';

import { faDownload } from '@fortawesome/pro-solid-svg-icons';

const DownloadButton = ({ data, icon, text }) => {
	const { t } = useTranslation();
	const { showError } = useAlert();
	const { getLocaleDateWithTime } = useLocale();
	const dispatch = useDispatch();

	const handleClick = async () => {
		dispatch(setLoading(true));
		try {
			const blob = await (await fetch(data.filePath)).blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			a.download = `${t(data.name, data.translationObject && JSON.parse(data.translationObject))}_${t(
				'export'
			)}_${getLocaleDateWithTime(data.requestDate)}.xlsx`
				.split(' ')
				.join('_');
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
			document.body.removeChild(a);
		} catch (error) {
			AppLogger.error(error);
			showError();
		} finally {
			dispatch(setLoading(false));
		}
	};

	return (
		<Button
			label={text}
			variant={'blueBorderless'}
			icon={icon}
			fullWidth
			css={css`
				margin: auto;
				gap: 1rem;
				> .typography,
				> .icon {
					font-size: var(--paragraph3-font-size) !important;
				}

				:hover {
					background-color: var(--table-selected-color) !important;
				}
			`}
			onClick={handleClick}
		/>
	);
};

const ExportFileStatus = ({ data }) => {
	if (!data || !data?.status) return;

	if (data?.expired === 'true') return <DownloadButton data={data} icon={faDownload} text="downloadExpired" />;
	if (data?.status === 'downloadAvailable' && data?.filePath)
		return <DownloadButton data={data} icon={faDownload} text="downloadAvailable" />;

	return <Status value={data.status} />;
};

export default ExportFileStatus;
